import { Helmet } from "react-helmet";
import { trackButtonClick } from "@/utils/analytics";
import ChatSvg from "../../../../public/assets/svg/live-chat/ChatSvg";
import { useSelector } from "react-redux";
import { globalCmsData } from "@/redux/cms/cmsSelectors";

const LivevoxChat = ({
  showContent = true,
  showContentTitle = true,
  contentTitle = "Live Chat Online",
  contentText = "Chat",
  style = {},
  onChatClick,
    hideContactUsTextClass = false,

}) => {
  const globalCms = useSelector(globalCmsData);

  const onPress = () => {
    onChatClick?.();

    trackButtonClick({
      eventName: "livevox_chat_open",
      eventCategory: "Live vox Click",
      eventSource: document.location.href,
    });

    var deviceWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    var liveWidgetId = deviceWidth > 767 ? 1003020 : 1003601;
    if (typeof LVWebWidget !== "undefined") {
      LVWebWidget.render({
        url: globalCms?.LivevoxUrl,
        uuid: globalCms?.LivevoxUUID,
        widgetId: liveWidgetId,
      });
    }
  };
  return (
    <>
      <Helmet>
        <script async defer src={globalCms?.LivevoxScriptUrl}></script>
      </Helmet>
      {showContent ? (
        <div
          id="pdpLiveChat"
          className="live-chat"
          tabIndex="0"
          onClick={onPress}
        >
          <ChatSvg />
          <div className="email-link">
            <div className="">{contentTitle}</div>
            <div className="contact-us-text">{contentText}</div>
          </div>
        </div>
      ) : (
        <a
          href="#"
          id="chatlivvox"
          // className="text-primary"
          style={{
            color: "#118cf4",
            textDecoration: "none",
            cursor: "pointer",
            ...style,
          }}
          onClick={onPress}
        >
          {showContentTitle && <div>{contentTitle}</div>}
          <div className={hideContactUsTextClass ? "" : "contact-us-text"}>{contentText}</div>
        </a>
      )}
    </>
  );
};

export default LivevoxChat;
